import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-3">
      <div className="w-12 h-12 rounded-2xl bg-lawn flex items-center justify-center animate-pulse">
        <Leaf className="w-6 h-6 text-white" />
      </div>
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  </div>
);

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const dash = user.role === "admin" ? "/admin" : user.role === "provider" ? "/provider" : "/dashboard";
    return <Navigate to={dash} replace />;
  }
  return children;
}
